<template>
  <div class="lyrics-store-logos-container">
    <div class="description">
      歌詞表示に対応している下記配信ストアに向けて、歌詞が登録できます。<br />
    </div>
    <div class="dsp-logo">
      <img src="/images/client/lyrics/logo_applemusic.jpg" />
      <img src="/images/client/lyrics/logo_spotify.jpg" />
      <img src="/images/client/lyrics/logo_amazon_prime_music.png" />
      <img src="/images/client/lyrics/logo_amazon_music_unlimited.png" />
      <br class="dsp-logo-wrap" />
      <img src="/images/client/lyrics/logo_line_music.jpg" />
      <img src="/images/client/lyrics/logo_recochoku.jpg" />
      <img
        src="/images/client/lyrics/logo_d_music.jpg"
        class="dsp-logo-dmusic" />
      <img src="/images/client/lyrics/logo_d_hits.jpg" />
      <br class="dsp-logo-wrap" />
      <img src="/images/client/lyrics/logo_awa.jpg" />
      <img src="/images/client/lyrics/logo_utapass.png" />
      <img src="/images/client/lyrics/logo_rakuten.png" />
      <br class="dsp-logo-wrap" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LyricsStoreLogos',
}
</script>

<style scoped>
.lyrics-store-logos-container {
  width: 100%;
  box-sizing: border-box;
}

.description {
  margin-bottom: 10px;
}

@media screen and (min-width: 896px) {
  .lyrics-store-logos-container {
    padding: 10px 40px;
  }

  .dsp-logo {
    margin: 20px auto 40px auto;
  }

  .dsp-logo IMG {
    max-width: 150px;
    min-height: 16px;
    max-height: 60px;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .dsp-logo .dsp-logo-dmusic {
    max-width: 120px;
    min-height:15px;
    margin-top:0;
  }
}
@media screen and (max-width: 895px) {
  .lyrics-store-logos-container {
    padding: 10px 20px;
  }

  .dsp-logo {
    margin: 10px auto 20px auto;
  }

  .dsp-logo IMG {
    max-width: 90px;
    min-height: 12px;
    max-height: 36px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
  .dsp-logo .dsp-logo-dmusic {
    max-width: 80px;
    min-height:12px;
  }
  .dsp-logo-wrap {
    display: none;
  }
}
</style>
